/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailoptional1Inputs */

const en_emailoptional1 = /** @type {(inputs: Emailoptional1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email (Optional)`)
};

const de_emailoptional1 = /** @type {(inputs: Emailoptional1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail (optional)`)
};

/**
* | output |
* | --- |
* | "Email (Optional)" |
*
* @param {Emailoptional1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailoptional1 = /** @type {((inputs?: Emailoptional1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailoptional1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailoptional1(inputs)
	return de_emailoptional1(inputs)
});
export { emailoptional1 as "emailOptional" }